/**
 * Value of awareness event.
 */
export enum AwarenessEventValue {
  AlarmDetected = 'AlarmDetected',
  AlarmAcknowledged = 'AlarmAcknowledged'
}